import { useState } from "react";
import useSWR from "swr";
import { fetcher, pairLabel } from "@/lib/api";

export function ThresholdPreview({ current, onPick }) {
  const [days, setDays] = useState(1);
  const { data } = useSWR(`/signals/threshold-preview?days=${days}`, fetcher);
  const max = Math.max(1, ...(data?.rows || []).map((r) => r.directional_passing));
  return (
    <div className="bg-[#1e2329] rounded p-2 mt-2" data-testid="threshold-preview">
      <div className="flex items-center justify-between gap-2">
        <div className="text-[10px] font-bold tracking-widest text-[#848e9c]">THRESHOLD PREVIEW · what would have fired</div>
        <div className="seg" data-testid="threshold-days">{[[1, "24h"], [7, "7d"], [30, "30d"]].map(([d, l]) => <button key={d} onClick={() => setDays(d)} className={days === d ? "on" : ""} data-testid={`threshold-days-${d}`}>{l}</button>)}</div>
      </div>
      {data && (
        <>
          <div className="mono text-[10px] text-[#848e9c] mt-1" data-testid="threshold-summary">{data.total_signals} signals · {data.hold} HOLD · {data.directional} directional · {data.executed} executed</div>
          <div className="space-y-1 mt-2">
            {data.rows.map((r) => {
              const isCur = Math.abs(r.threshold - current) < 1e-9;
              return (
                <button key={r.threshold} onClick={() => onPick?.(r.threshold)} className={`w-full grid grid-cols-[36px_1fr_auto] gap-2 items-center text-left rounded px-1 py-0.5 hover:bg-[#2b3139] ${isCur ? "bg-[#2b3139]" : ""}`} title={r.pairs.join(", ") || "no pairs"} data-testid={`threshold-row-${r.threshold}`}>
                  <span className={`mono text-[11px] ${isCur ? "text-[#fcd535]" : "text-[#eaecef]"}`}>{Math.round(r.threshold * 100)}%</span>
                  <div className="relative h-3 bg-[#0b0e11] rounded overflow-hidden">
                    <div className="absolute inset-y-0 left-0 bg-[#0ecb81]" style={{ width: `${(r.would_fire / max) * 100}%` }} />
                    <div className="absolute inset-y-0 bg-[#f6465d]/70" style={{ left: `${(r.would_fire / max) * 100}%`, width: `${(r.blocked_by_other_rules / max) * 100}%` }} />
                  </div>
                  <span className="mono text-[10px] text-[#848e9c] whitespace-nowrap" data-testid={`threshold-count-${r.threshold}`}><span className="text-[#0ecb81]">{r.would_fire}</span> fire{r.blocked_by_other_rules ? <span className="text-[#f6465d]"> +{r.blocked_by_other_rules} risk-blocked</span> : ""}{r.pairs.length ? ` · ${r.pairs.map((p) => pairLabel(p)).join(" ")}` : ""}</span>
                </button>
              );
            })}
          </div>
          <div className="text-[10px] text-[#5e6673] mt-1">Green = would execute at that threshold; red = passes confidence but another risk rule blocks it. Click a row to set the slider. HOLD verdicts never fire regardless of threshold.</div>
        </>
      )}
    </div>
  );
}
